<template>
    <declaration-write-link :writeLayout="writeLayout" :declarationData="declarationData"></declaration-write-link>
</template>

<script>
    import DeclarationWriteLink from "@/components/declaration/DeclarationWriteLink";
    import dateMixins from "@/mixins/dateMixins";
    import alertMixins from "@/mixins/alertMixins";
    import declarationUtil from "@/components/declaration/declarationUtil";
import EventBus from "@/utils/event-bus";


    export default {
        name: "DeclarationChatDetailComponent",
        mixins: [dateMixins, alertMixins,declarationUtil],
        components: {
            DeclarationWriteLink
        },
        inject: ['changeLoading'],
        provide() {
            return{
                runDeleteConfirm:this.runDeleteConfirm,
            }
        },
        props: {
            reportIdx:"",
            declarationType:"",
        },
        data() {
            return{
                declarationData:{},
                getData: false,
                writeLayout:'',
                getFunc:'',
                deleteFunc:'',
                keyName:'',
            }
        },
        created() {
            this.initConfig();
            if(this.reportIdx != ''){
                this.getDetail();
            }
        },
        mounted() {
        },
        beforeDestroy() {
        },
        destroyed() {},
        computed: {
        },
        methods:{
            initConfig() {
                let config = this.returnDeclarationConfig(this.declarationType)
                this.writeLayout = config.writeLayout;
                this.getFunc = config.getFunc;
                this.deleteFunc = config.deleteFunc;
                this.keyName = config.keyName;
            },


            getDetail() {
                let params = {
                    id:this.reportIdx
                }
                this.$api.$declaration[this.getFunc](params).then(res=> res.Data.Result).then(res => {
                    this.declarationData = res.List[0];
                });
            },  
        runDeleteConfirm() {
                this.createConfirm({
                    content: '정말 삭제하시겠습니까?',
                    confirm: () => {
                        this.changeLoading(true)
                        this.runDelete();
                    }
                })
            },
            deleteAfterFunc() {
                this.changeLoading(false);
                this.createAlert({
                    content: '삭제되었습니다.',
                    hide: () => {
                        this.$router.back();
                    }
                })
            },
        runDelete() {
            let params = {}
            if(this.keyName){
                params[this.keyName] = this.reportIdx;
            }
                this.$api.$declaration[this.deleteFunc](params).then(res=> res.Data.Result).then(res => {
                    if(res.Info.status){
                        this.deleteAfterFunc();
                    }else {
                        this.createAlert({
                            content: '삭제가 실패되었습니다.',
                            hide: () => {
                                this.$router.back();
                            }
                        })      
                    }
                });
        }
        },
        watch: {

        },
    }
</script>

<style scoped>

</style>
